export const useLocale=()=> 'en';
export const t=(source,values)=>values?source.replace(/\{(\d+)\}/g,(match,index)=>String(values[index]??match)):source;
